"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationRenovationPlan',
  data: function data() {
    return {
      loading: false,
      list: []
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        confirm: '确认',
        start: '开工',
        complete: '完工'
      }[value] || value;
    },
    reload: function reload() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationRenovationPlanListApi)({
        page: 1,
        limit: 50
      }).then(function (data) {
        _this.list = data.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('计划/房屋名称', '新增装修计划').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationRenovationPlanSaveApi)({
          propertyName: value || 'E2E装修计划',
          communityName: '测试小区',
          layout: '三室两厅',
          buildingArea: 100,
          budgetAmount: 200000,
          houseType: 'new'
        }).then(function () {
          _this2.$message.success('已保存');
          _this2.reload();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      (0, _decoration.decorationRenovationPlanActionApi)(row.plan.id, {
        action: action
      }).then(function () {
        _this3.$message.success('已更新');
        _this3.reload();
      });
    }
  }
};